"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signature = exports.generic = exports["default"] = void 0;
var signature = exports.signature = 'signature';
var generic = exports.generic = 'generic';
var _default = exports["default"] = {
  signature: signature,
  generic: generic
};